import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import VATDefinitionForm from 'Services/ProductManagement/Features/VATDefinition/Components/VATDefinitionForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function VATDefinitionCreatePage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/vat-definitions`
  const previousLocation = usePreviousLocation(baseUrl)
  const breadcrumbs = [
    {
      title: t`Settings`
    },
    {
      title: t`VAT definitions`,
      link: baseUrl
    },
    {
      title: t`Create new VAT definition`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new VAT definition`}</PageTitle>
        </Grid>
      </Grid>
      <VATDefinitionForm successBaseUrl={previousLocation} />
    </Box>
  )
}
